module.exports = __webpack_public_path__ + "static/media/resetFilters.999124e0.svg";